import React from 'react';
import _ from 'lodash';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import { green } from '@mui/material/colors';
import { useQuery } from 'react-fetching-library';
import { useDispatch, useSelector } from 'react-redux';
import { useDebouncedCallback } from 'use-debounce';
import { useTranslation } from 'react-i18next';

import { getModulesAction } from '../../../../services/request';
import { setModule } from '../../../../services/redux-actions';

const styles = {
  select: {
    '.MuiOutlinedInput-notchedOutline': {
      borderColor: green[400]
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: green[600]
    },
    width: '100%'
  }
};

export const ModuleList = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { module } = useSelector(state => state.app);
  const { loading, payload, error } = useQuery(getModulesAction(null, 'GET'));
  const [modules, setModules] = React.useState([]);

  React.useEffect(() => {
    if (!loading && !error) {
      setModules(payload);
      if (!module) {
        dispatch(setModule(payload[0].identifier));
      }
    }
  }, [loading]);

  const handleChange = useDebouncedCallback(val => {
    dispatch(setModule(val));
  }, 50
  );

  return (
    <Box>
      <InputLabel id="modules"><Typography color="primary">{t('module')}</Typography></InputLabel>
      <Select
        sx={styles.select}
        variant="standard"
        labelId="modules"
        value={module}
        defaultValue={module}
        label="Moduły"
        onChange={e => handleChange(e.target.value)}
      >
        { !_.isEmpty(modules)
          ? _.map(modules, obj => (
            <MenuItem key={obj.id} value={obj.identifier}>{obj.name}</MenuItem>
          ))
          : []}
      </Select>
    </Box>
  );

};
